import { render, staticRenderFns } from "./platform-orgs.vue?vue&type=template&id=1505b442&scoped=true"
import script from "./platform-orgs.vue?vue&type=script&lang=js"
export * from "./platform-orgs.vue?vue&type=script&lang=js"
import style0 from "./platform-orgs.vue?vue&type=style&index=0&id=1505b442&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1505b442",
  null
  
)

export default component.exports